












import {Component, Vue, Watch} from 'vue-property-decorator';
import SupplierForm from '@/screens/dashboard/supplier/SupplierForm.vue';
import {ISupplier} from '@/models/ISupplier';
import {getSupplierById} from '@/services/SupplierService';
import {ModuleShop} from '@/store/modules/ShopModule';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';

@Component({
  components: {
    SupplierForm
  }
})
export default class EditSupplierScreen extends Vue {
  supplier: ISupplier | null = null;
  loading: boolean = true;

  get supplierId() {
    return this.$route.params.supplierId;
  }

  get shopId() {
    return ModuleShop.shopId;
  }

  get organizationId() {
    return ModuleOrganization.organizationId;
  }

  @Watch('shopId', {immediate: true})
  async loadData() {
    try {
      this.loading = true;
      this.supplier = await getSupplierById(this.organizationId, this.shopId, parseInt(this.supplierId.substring(this.supplierId.length - 1), 10));
      parseInt(this.supplierId.substring(this.supplierId.length - 1), 10);
    } finally {
      this.loading = false;
    }
  }
}
